import { Eye } from "../Icons/general-interface-1";
import styles from "./index.module.scss";
import { Text } from "../Type/index";

const ReadOnly = ({ className }: { className?: string }) => {
  return (
    <div className={className}>
      <Text size="medium" weight="regular" className={styles.text}>
        <Eye className={styles.icon} />
        Read-only
      </Text>
    </div>
  );
};

export default ReadOnly;
